import { render, staticRenderFns } from "./ParentPaymentPage.vue?vue&type=template&id=e92c2f3a&"
import script from "./ParentPaymentPage.vue?vue&type=script&lang=js&"
export * from "./ParentPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports